import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { icon } from 'src/config/dataConf'
import routes from 'src/routing/routes'

let Marker, Popup, MarkerClusterGroup, TileLayer
class MapCore extends Component {
  constructor(props) {
    super(props)
    this.state = {
      heightWindow:
        typeof window !== 'undefined'
          ? window.innerHeight - 83.75
          : 600 - 83.75,
      infoProducer: null
    }
    if (typeof window !== 'undefined') {
      Marker = require('react-leaflet').Marker
      Popup = require('react-leaflet').Popup
      TileLayer = require('react-leaflet').TileLayer

      MarkerClusterGroup = require('react-leaflet-markercluster/src/react-leaflet-markercluster')
        .default
    }

    this.handleMarkerClickCache = {}
  }

  getDataProducer = arrayIndex => {
    this.setState({ infoProducer: this.props.producers[arrayIndex] })
  }

  handleMarkerClick = arrayIndex => {
    if (!(arrayIndex in this.handleMarkerClickCache)) {
      this.handleMarkerClickCache[arrayIndex] = () => {
        return this.getDataProducer(arrayIndex)
      }
    }

    return this.handleMarkerClickCache[arrayIndex]
  }

  render() {
    const { producers } = this.props
    return (
      <Fragment>
        <TileLayer
          url={routes.urlTiles}
          attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a>'
        />
        <MarkerClusterGroup>
          {producers.map((producer, i) => {
            const selected =
              this.state.infoProducer &&
              this.state.infoProducer.id === producer.id

            return (
              <Marker
                key={producer.id}
                icon={icon}
                position={[
                  producer.addressCoordinates[1],
                  producer.addressCoordinates[0]
                ]} // [lat, lng]
                onClick={this.handleMarkerClick(i)}
              >
                <Popup>
                  <span>
                    {selected ? (
                      <Fragment>
                        {this.state.infoProducer.companyName} <br />
                        {`${this.state.infoProducer.addressCity} ${this.state.infoProducer.addressPostalCode}`}
                        <br />
                        <a
                          href={routes.ficheProducteur.replace(
                            ':id(\\d+)',
                            this.state.infoProducer.id
                          )}
                        >
                          Voir la fiche
                        </a>
                      </Fragment>
                    ) : (
                      'chargement...'
                    )}
                  </span>
                </Popup>
              </Marker>
            )
          })}
        </MarkerClusterGroup>
      </Fragment>
    )
  }
}

MapCore.propTypes = {
  producers: PropTypes.array.isRequired
}

export default MapCore
